import { useQuery, useQueryClient } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { API_URL } from '@/config';
import storage from '@/utils/storage';

export const getFlowscaleUser = async (): Promise<any> => {
  const access_token = storage.getAccessToken();

  if (!access_token) {
    return;
  }
  try {
    const response = await axios.get(`${API_URL}/v1/user`);

    if (response?.data?.status === 'inactive' || response?.data?.is_active === false) {
      storage.clearAllTokens();
      window.location.assign('/');
    }
    return response.data;
  } catch (error) {
    // console.error('Error getFlowscaleUser:', error);
    // throw error;
  }
};

export const useGetFlowscaleUser = (config = {}) => {
  const { addNotification } = useNotificationStore();
  const queryClient = useQueryClient();

  return useQuery<any, Error>({
    queryKey: ['flowscaleUser'],
    // refetchInterval: 10000,
    queryFn: () => getFlowscaleUser(),
    onError: (error) => {},
    onSuccess: (data) => {
      // Handle success here if needed
      queryClient.invalidateQueries(['allProjects']);
    },
    ...config,
  });
};
